module.exports = {
  accountType: require('./accountType'),
  claimType: require('./claimType'),
  dictOperationReason: require('./dictOperationReason'),
  error: require('./error'),
  personType: require('./personType'),
  pixKeyType: require('./pixKeyType'),
  qrcodeAgentMode: require('./qrcodeAgentMode'),
  qrcodeResponseFormat: require('./qrcodeResponseFormat'),
  qrcodeStatus: require('./qrcodeStatus'),
  qrcodeValueChangeMode: require('./qrcodeValueChangeMode')
};
